export default __webpack_public_path__ + "static/media/valores.c3a6bbc7.png";